
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 543.22 277.67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"fill":"#eeedf5","opacity":".3","d":"M0 0h543.22v268.14H0z"}}),_c('path',{attrs:{"d":"M271.59 197.37a63.52 63.52 0 010-127 63.13 63.13 0 0125.86 5.5 5 5 0 11-4.07 9.13 53.07 53.07 0 00-21.78-4.64 53.52 53.52 0 000 107 53.58 53.58 0 0053.52-53.51v-5.38a5 5 0 1110 0v5.38a63.6 63.6 0 01-63.53 63.52z","fill":"#02a378","data-name":"Path 1945"}}),_c('path',{attrs:{"d":"M271.61 150.62a5 5 0 01-3.54-1.46l-17.55-17.55a5 5 0 117.08-7.08l14 14 55-55a5 5 0 017.08 7.06l-58.5 58.56a5 5 0 01-3.54 1.47z","fill":"#02a378","data-name":"Path 1946"}})])
          )
        }
      }
    